import { Spacing } from '@persona-id/design-tokens';
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

const Container = styled.div.attrs<{ position: FloatingContentProps['position'] }>(
  ({ position }) => ({
    style: (() => {
      switch (position) {
        case 'top-left':
          return { top: Spacing[4], left: Spacing[4] };
        case 'top-center':
          return { top: Spacing[4], left: '50%', transform: 'translateX(-50%)' };
        case 'top-right':
          return { top: Spacing[4], right: Spacing[4] };
        case 'bottom-left':
          return { bottom: Spacing[4], left: Spacing[4] };
        case 'bottom-center':
          return { bottom: Spacing[4], left: '50%', transform: 'translateX(-50%)' };
        case 'bottom-right':
          return { bottom: Spacing[4], right: Spacing[4] };
      }
    })(),
  }),
)<{ position: FloatingContentProps['position'] }>`
  position: absolute;
  background-color: transparent;
`;

interface FloatingContentProps {
  position:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-right'
    | 'bottom-center'
    | 'bottom-left';
}

const FloatingContent: FC<PropsWithChildren<FloatingContentProps>> = ({ children, position }) => {
  return <Container position={position}>{children}</Container>;
};

export default FloatingContent;
